import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=07a7c4bd"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=07a7c4bd&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a7c4bd')) {
      api.createRecord('07a7c4bd', component.options)
    } else {
      api.reload('07a7c4bd', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=07a7c4bd", function () {
      api.rerender('07a7c4bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sign-in/components/start-new-train-dialog/Index.vue"
export default component.exports